function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.8522 7.40625H0.429688V28.1443H3.8522V7.40625Z",
  fill: "black"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.4881 10.7527C22.9077 8.30688 20.0507 6.98047 17.2621 6.98047C11.682 6.98047 7.24609 11.5884 7.24609 17.7927C7.24609 23.9616 11.7503 28.5696 17.2621 28.5696C18.6404 28.5696 19.9853 28.2154 21.2953 27.5422C22.6402 26.869 23.7146 25.9674 24.4881 24.7268V28.1448H27.7928V7.40523H24.4881V10.7527ZM17.2985 25.0289C13.5808 25.0289 10.5945 21.8118 10.5945 17.7574C10.5945 13.7352 13.5808 10.4859 17.2985 10.4859C21.1106 10.4859 24.0664 13.7367 24.0664 17.7574C24.0664 21.8118 21.1106 25.0289 17.2985 25.0289Z",
  fill: "black"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M55.4722 6.90234C51.961 6.90234 49.5621 8.23029 48.3408 10.8494C47.1733 8.4097 44.5083 6.90234 41.3445 6.90234C38.6592 6.90234 36.6164 7.85 35.4213 9.64564V7.3271H32.0293V28.2185H35.4547V16.9432C35.4547 12.7462 37.6952 10.0336 41.1628 10.0336C44.3541 10.0336 46.4972 12.254 46.4972 15.5585V28.22H49.8398V16.3191C49.8398 14.387 50.4591 12.6895 51.5845 11.5425C52.5877 10.5197 53.9456 9.98453 55.4112 10.0351C58.7159 10.1501 60.6874 12.3353 60.6874 15.879V28.2216H64.0009V15.9143C64.0009 13.2461 63.1954 10.9843 61.6717 9.37269C60.1495 7.75493 58.0035 6.90234 55.4722 6.90234Z",
  fill: "black"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M2.14016 0C0.95813 0 0 1.01053 0 2.2572C0 3.50388 0.95813 4.51441 2.14016 4.51441C3.3222 4.51441 4.28033 3.50388 4.28033 2.2572C4.27887 1.01053 3.32074 0 2.14016 0Z",
  fill: "black"
});
const SvgIamLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 29,
    viewBox: "0 0 64 29",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIamLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/iam_logo.48ece59e.svg";
export { ForwardRef as ReactComponent };